import styled from "styled-components";
import { LoadingProps } from "./Loading.types";
import { setThemeColor } from "../../setThemeColor";

export const StyledLoading = styled.div<LoadingProps>`
  display: inline-block;
  width: 80px;
  height: 80px;

  &::after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;

    animation: loading-ring 1.2s linear infinite;

    border: 6px solid
      ${(props) =>
        props.variant ? props.theme[props.variant] : props.theme.primaryColor};
    border-color: ${(props) =>
        props.variant ? props.theme[props.variant] : props.theme.primarycolor}
      transparent
      ${(props) =>
        props.variant ? props.theme[props.variant] : props.theme.primaryColor}
      transparent;
  }

  @keyframes loading-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
